import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/redux-hooks";
import { getSitemap } from "../../api/asyncThuncks/sitemap";
import { selectMainState } from "../../store/slices/main";

const SitemapViewer = () => {
  const dispatch = useAppDispatch();
  const { sitemap } = useAppSelector(selectMainState);

  useEffect(() => {
    dispatch(getSitemap());
  }, [dispatch]);

  return (
    <div className="xml-viewer bg-black text-white">
      <pre>{sitemap}</pre>
    </div>
  );
};

export default SitemapViewer;
